/* eslint-disable no-prototype-builtins */
import PropTypes from 'prop-types';
import React from 'react';

import { isEmpty, isEqual } from 'lodash';
import turf from '@turf/turf';

import { Bert } from 'meteor/themeteorchef:bert';

import { Select, FormControl, InputLabel, MenuItem, Stack, TextField } from '@mui/material';
import useTimeStore from '../ZustandProvider';

import * as annotationOps from '../../../api/Annotations/annotation-operations';

const CenterMap = ({
  startCoords,
  startMode,
  map,
  updatedAnnotation,
  elementToRender,
  handleCenterMap,
  widthSelector,
  isSettingsMode,
  ...rest
}) => {
  const coordOnMap = useTimeStore(state => state.coordOnMap);
  const { selectedAnnotation } = rest;
  const centerMode = ['Current Location', 'Annotation', 'Default Map', 'Manual'];
  const startLat = !isEmpty(startCoords) ? startCoords[0] : '';
  const startLong = !isEmpty(startCoords) ? startCoords[1] : '';

  const [modeCenterSelected, setModeCenterSelected] = React.useState(startMode);
  const startModeManual = isEqual(startMode, centerMode[centerMode.length - 1]);
  const [isManual, setIsManual] = React.useState(startModeManual);
  const [latitud, setLatitud] = React.useState(startLat);
  const [longitud, setLongitud] = React.useState(startLong);

  const centerDefaultMap = mode => {
    if (!isEmpty(map)) {
      const { coordinates } = map.mapLocation.geometry;

      if (!isEmpty(coordinates)) {
        setIsManual(false);
        setLatitud(coordinates[1]);
        setLongitud(coordinates[0]);
        handleCenterMap([coordinates[1], coordinates[0]], mode);
      } else {
        Bert.alert('Coordinates do not exist', 'danger');
      }
    } else Bert.alert('Do not exist map', 'danger');
  };

  const centerAnnotation = mode => {
    let coords = [];
    if (!isEmpty(selectedAnnotation) && isEmpty(coordOnMap)) {
      const geojson = annotationOps.getGeoJSON(selectedAnnotation);
      coords = turf.getCoord(geojson);
    } else if (!isEmpty(coordOnMap)) {
      const { lat, lng } = coordOnMap;
      coords = [lng, lat];
    } else if (!isEmpty(updatedAnnotation) && isEmpty(selectedAnnotation)) {
      coords = updatedAnnotation.geoJSON.geometry.coordinates;
    }

    if (!isEmpty(coords)) {
      setLatitud(coords[1]);
      setLongitud(coords[0]);
      handleCenterMap([coords[1], coords[0]], mode);
      setIsManual(false);
    } else if (isSettingsMode) handleCenterMap([], mode);
    else Bert.alert('Coordinates do not exist', 'danger');
  };

  const centerCurrentLocation = mode => {
    navigator.geolocation.getCurrentPosition(position => {
      const coordinates = [position.coords.latitude, position.coords.longitude];
      if (!isEmpty(coordinates)) {
        setIsManual(false);
        setLatitud(position.coords.latitude);
        setLongitud(position.coords.longitude);
        handleCenterMap(coordinates, mode);
      } else {
        Bert.alert('Coordinates do not exist', 'danger');
      }
    });
  };

  const centerManual = (mode, coords) => {
    setIsManual(true);
    if (!isEmpty(coords)) handleCenterMap(coords, mode);
  };

  const handleMapCenter = (mode, coords = []) => {
    setModeCenterSelected(mode);
    switch (mode) {
      case 'Current Location':
        centerCurrentLocation(mode);
        break;
      case 'Annotation':
        centerAnnotation(mode);
        break;
      case 'Default Map':
        centerDefaultMap(mode);
        break;
      case 'Manual':
        centerManual(mode, coords);
        break;

      default:
        handleCenterMap([], 'none');
        break;
    }
  };

  React.useEffect(() => {
    if (!isEmpty(elementToRender)) {
      if (
        elementToRender.hasOwnProperty('centerMode') &&
        elementToRender.hasOwnProperty('coordsCenter')
      ) {
        let coordsProp = [];
        if (isEqual(elementToRender.centerMode, centerMode[centerMode.length - 1])) {
          setLatitud(elementToRender.coordsCenter[0]);
          setLongitud(elementToRender.coordsCenter[1]);
          coordsProp = elementToRender.coordsCenter;
        }
        handleMapCenter(elementToRender.centerMode, coordsProp);
      }
    }
  }, [elementToRender.mode, elementToRender.coords]);
  return (
    <FormControl fullWidth>
      <>
        <InputLabel id="mapcenter">Map Center</InputLabel>
        <Select
          labelId="select-centerMap"
          id="select-centerMap"
          size="small"
          style={{ width: widthSelector }}
          value={modeCenterSelected}
          onChange={event => handleMapCenter(event.target.value)}
        >
          <MenuItem value="none">------</MenuItem>
          {centerMode.map(mode => (
            <MenuItem key={mode} value={mode}>
              {mode}
            </MenuItem>
          ))}
        </Select>
        {isManual && (
          <Stack
            width="50%"
            paddingTop="2%"
            direction="row"
            sx={{
              justifyContent: 'space-between'
            }}
          >
            <TextField
              label="Latitud"
              defaultValue={latitud}
              size="small"
              onBlur={event => {
                setLatitud(event.target.value);
                handleCenterMap([event.target.value, longitud], 'Manual');
              }}
            />
            <TextField
              label="Longitud"
              size="small"
              defaultValue={longitud}
              onBlur={event => {
                setLongitud(event.target.value);
                handleCenterMap([latitud, event.target.value], 'Manual');
              }}
            />
          </Stack>
        )}
      </>
    </FormControl>
  );
};

CenterMap.defaultProps = {
  widthSelector: '50%',
  startCoords: [],
  startMode: 'none',
  map: {},
  updatedAnnotation: {},
  isSettingsMode: false
};

CenterMap.propTypes = {
  widthSelector: PropTypes.string,
  startCoords: PropTypes.array,
  startMode: PropTypes.string,
  map: PropTypes.object,
  updatedAnnotation: PropTypes.object,
  elementToRender: PropTypes.object.isRequired,
  handleCenterMap: PropTypes.func.isRequired,
  isSettingsMode: PropTypes.bool
};
export default CenterMap;
